<div class="col-12">
  <div class="col-10 offset-2" style="padding-left: 10px;">
    <img class="imagen" src="https://s3.amazonaws.com/dev.structure.files/assets/smartphone.png" *ngIf="stepId === 0"/>
  </div>
  <div class="col-10 offset-1">
    <img class="imagen" src="https://s3.amazonaws.com/dev.structure.files/assets/smartphone-step2.png" *ngIf="stepId === 1"/>
    <img class="imagen margin-extra" src="https://s3.amazonaws.com/dev.structure.files/assets/smartphone-step2.png" *ngIf="stepId === 2"/>
  </div> 
  <div class="col-10 offset-1" *ngIf="stepId != 0">
    <mat-grid-list cols="3" rowHeight="2:1.3" class="modules-list">
      <mat-grid-tile class="icon-tree" *ngFor="let item of iconAvailableList">
        <img class="image-tree" src="{{ item.url }}" />
        <p> {{ item.name }} </p>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>
